// extracted by mini-css-extract-plugin
export default {"add-to-cart-btn":"AddToCartBtn_add-to-cart-btn__rUtXp","main-button":"AddToCartBtn_main-button__oTaVm","main-button-text":"AddToCartBtn_main-button-text__An62P"};